import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {useTheme} from "../../../../../connectui/theme/ThemeProvider";
import {buildStyles} from "../../../../../connectui/component/buildStyles";
import Container from "../../../../../connectui/component/layout/Container";
import DropdownExpand from "../../../../../connectui/component/display/dropdown/DropdownExpand";
import FlexContainer from "../../../../../connectui/component/layout/FlexContainer";
import Text from "../../../../../connectui/component/display/Text";
import SvgIcon from "../../../../../connectui/component/display/SvgIcon";
import ICONS from "../../../../../connectui/icons/iconMap";
import {postAccessCode} from "../../../../../redux/actions/experiencesActions";
import DeviceAccessCodeEntry from "../../../admin/device/DeviceAccessCodeEntry";
import ConfirmModal from "../../../../../connectui/component/modal/ConfirmModal";
import ButtonText from "../../../../../connectui/component/input/button/ButtonText";
import OutlinedButtonBase from "../../../../../connectui/component/input/button/base/OutlinedButtonBase";
import ErrorButtonBase from "../../../../../connectui/component/input/button/base/ErrorButtonBase";
import RoundIcon from "../../../../../connectui/component/display/RoundIcon";

const useStyles = (theme) =>
  buildStyles({
    cardContainer: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      padding: theme.spacing(2, 3, 0),
      borderBottom: `1px solid ${theme.colors.border}`,
    },
  });

const AccessCodesCard = ({booking}) => {
  const {theme} = useTheme();
  const classes = useStyles(theme);
  const dispatch = useDispatch();

  const [expanded, setExpanded] = useState(false);
  const [visibilities, setVisibilities] = useState({});
  const [codeToBeRevoked, setCodeToBeRevoked] = useState(null);
  const [loading, setLoading] = useState(false);

  const lockCodes = booking?.lock_codes ?? [];

  // Initialize visibility states
  useEffect(() => {
    const newVisibilities = {};
    lockCodes.forEach((lc) => (newVisibilities[lc.access_code] = false));
    setVisibilities(newVisibilities);
  }, [booking]);

  const toggleVisibility = (accessCode) => {
    setVisibilities((prev) => ({...prev, [accessCode]: !prev[accessCode]}));
  };

  const handleRevokeCode = () => {
    setLoading(true);
    dispatch(
      postAccessCode({
        action: {
          action_id: "delete_temporary_codes",
          code: codeToBeRevoked.access_code,
        },
        deviceID: codeToBeRevoked.device_ids?.[0],
        bookingID: booking.booking_id,
        guestID: booking.guest_id,
        onSuccess: () => {
          setCodeToBeRevoked(null);
          setLoading(false);
        },
        onError: () => {
          setLoading(false);
        },
      }),
    );
  };

  const toggleExpanded = () => {
    // if (!Object.keys(devices).length) {
    //   let params = `enso_key=${current_user}`;
    //   dispatch(getDevices(params));
    // }
    setExpanded((prev) => !prev);
  };

  if (!lockCodes?.length) {
    return null;
  }

  return (
    <Container className={classes.cardContainer}>
      <ConfirmModal
        isOpen={codeToBeRevoked !== null}
        title={"Revoke Access Code?"}
        description={
          "Any guests with this access code will lose access to this lock."
        }
        actions={
          <FlexContainer gap={theme.spacing(3)} sx={{flex: 1}}>
            <ButtonText
              buttonBase={OutlinedButtonBase}
              weight="semibold"
              color="gray700"
              sx={{flex: 1, padding: theme.spacing(2.5, 4.5)}}
              label={"Cancel"}
              onClick={() => setCodeToBeRevoked(null)}
            />
            <ButtonText
              buttonBase={ErrorButtonBase}
              weight="semibold"
              color="white"
              sx={{flex: 1, padding: theme.spacing(2.5, 4.5)}}
              label={loading ? "Revoking..." : "Revoke"}
              onClick={handleRevokeCode}
            />
          </FlexContainer>
        }
        icon={
          <RoundIcon iconComponent={"alert-triangle"} baseColor={"warning"} />
        }
      />
      <DropdownExpand
        customLabel={
          <FlexContainer
            justifyContent={"space-between"}
            alignItems={"center"}
            sx={{width: "100%"}}
          >
            <FlexContainer alignItems="center" gap={theme.spacing(1)}>
              <SvgIcon
                component={ICONS.key}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "16px",
                  height: "16px",
                  color: theme.colors.textPrimary,
                }}
              />
              <Text variant="textSM" weight="medium">
                {"Access Codes"}
              </Text>
              <Text
                variant="textXS"
                weight="medium"
                color="textSecondary"
                sx={{marginLeft: theme.spacing(1)}}
              >
                {`${lockCodes?.length || 0} Codes`}
              </Text>
            </FlexContainer>
          </FlexContainer>
        }
        divider={false}
        expanded={expanded}
        onExpand={toggleExpanded}
      >
        {lockCodes.map((lockCode) => (
          <Container
            key={lockCode.access_code}
            padding={`${theme.spacing(2)} 0px`}
          >
            <DeviceAccessCodeEntry
              deviceCode={lockCode}
              visible={visibilities[lockCode.access_code]}
              toggleVisibility={toggleVisibility}
              onDelete={() => setCodeToBeRevoked(lockCode)}
            />
          </Container>
        ))}
      </DropdownExpand>
    </Container>
  );
};

export default AccessCodesCard;
